<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
          <a-form-item label="关键字">
              <a-input  v-model="searchP.keyword"  placeholder="编码/名称" ></a-input>
          </a-form-item>
          
          <a-form-item label="平台编码">
                <platformSelecter :isDisabled="false" :showAll='true' v-model="searchP.platformtype"></platformSelecter>

          </a-form-item>
         

          <a-form-item label="渠道状态">
              <a-radio-group  v-model="searchP.status">
                  <a-radio value="">
                    全部
                    </a-radio>
                    <a-radio value="02">
                    开启
                    </a-radio>
                    <a-radio value="01">
                    未开启
                    </a-radio>
                </a-radio-group>
          </a-form-item>

          <a-form-item>
                <a-button type="primary"  @click="handleSubmit">查询</a-button>
          </a-form-item>
      </a-form>
</template>

<script>
import platformSelecter from '../../components/platformSelecter'

export default {
    components:{
        platformSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                keyword:'',
                status:'',
                platformtype:''
            }
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

